import React from 'react';
import SalesIndex from '../join';

export default function () {
  return <SalesIndex noExitIntent noFixedVideo ctaOverride="sales297" ctaNoTimer variant="ad"/>;
}
